import { CategoryTreeItemV2, CategoryTreeOptionV2, CategoryTreeRequestOption } from '../../../types/category/tree';
import { useQuery } from '@tanstack/react-query';
import { CATEGORY } from '../../../constants/queryKeys';
import categoryApiV2 from '../../../lib/api/category/CategoryApiV2';

export const useCategoryTree = (option: CategoryTreeOptionV2 = {}) => {
  const { data: categoryTree } = useQuery(
    CATEGORY.LIST_TREE,
    () => categoryApiV2.getCategoryTree(new CategoryTreeRequestOption(option)),
    {
      select: (res) => {
        return res.categories.map((tree) => new CategoryTreeItemV2(tree));
      },
    },
  );

  return categoryTree || [];
};
